import React from 'react';
import { Outlet } from 'react-router-dom';
import UnifiedNavigation from '../platform/UnifiedNavigation';

export default function AdminContentLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Admin Navigation */}
      <UnifiedNavigation />

      {/* Content Area */}
      <main className="w-full">
        <Outlet />
      </main>
    </div>
  );
}
